import { AxiosResponse } from 'axios';
import axios from './api';
import { Attachment, Child, DownloadFileType, FileDeletedResponse, FilesResponseType, LoadFilesType } from './account.types';
import { AvailableSchoolFoodTypeResponse, QuitRegistration, QuitRegistrationResponse, RegistrationResponse } from './registrations.types';

export const getChildren = (): Promise<AxiosResponse<Child>> => {
  return axios.get('/vala/application-web/applicable-children');
};

export const registerChild = (data: any): Promise<AxiosResponse<RegistrationResponse>> => {
  return axios.post('/vala/application-web/registration', data);
};

export const uploadFile = (data: any): Promise<AxiosResponse<any>> => {
  return axios.post(
    `/vala/application-web/appl-upload-file?student_id=${data.student_id}&name=${data.name}&filename=${data.filename}&mime=${data.mime}&customer=${data.customer}&registration_id=${data.registration_id}`,
    data.body
  );
};

export const deleteFile = (attachment_id: number): Promise<AxiosResponse<FileDeletedResponse>> => {
  return axios.delete(`/vala/application-web/appl-download/${attachment_id}`);
};

export const getFiles = (data: LoadFilesType): Promise<AxiosResponse<FilesResponseType>> => {
  return axios.get(`/vala/application-web/files`, {
    params: data,
  });
};

// Load file to download
export const getFile = (data: Attachment, customer: number): Promise<AxiosResponse<any>> => {
  return axios.get(`/vala/application-web/appl-download/${data.attachment_id}`, {
    responseType: 'arraybuffer',
    params: {
      customer,
    },
  });
};

export const updateChild = (data: any): Promise<AxiosResponse<RegistrationResponse>> => {
  return axios.put('/vala/application-web/registration', data);
};

export const quitRegistration = (data: QuitRegistration): Promise<AxiosResponse<QuitRegistrationResponse>> => {
  return axios.post('/vala/application-web/quit-registration', data);
};

export const getSchoolFoodTypes = (school_id: number): Promise<AxiosResponse<AvailableSchoolFoodTypeResponse>> => {
  return axios.get('/vala/application-web/food-types-school', {
    params: { school_id },
  });
};
